export function onChangeLanguage() {
  document.body.addEventListener('click', (event) => {
    const target = event?.detail?.target ?? event?.target;

    /**
     * click sobre el boton de selección de idiomas
     */
    if (target?.getAttribute('action') === 'language') {
      const parser = new URL(window.location);
      parser.searchParams.set('lang', target.getAttribute('value'));
      window.location = parser.href;
    }
  });
}
